import React, { useState } from 'react';
import { EducationMaterialInterface } from '../../Models/EducationMaterials/EducationMaterial';
import styles from './EducationMaterialVideo.module.scss';
import BaseModal from '../../Modules/Base/Components/BaseModal/BaseModal';
import { Size } from '../../Enums/Size.enum';

interface Props {
	item: EducationMaterialInterface;
}

export const withAutoplay = (url: string): string =>
	url.includes('?') ? `${url}&autoplay=1` : `${url}?autoplay=1`;

const EducationMaterialVideo: React.FC<Props> = ({ item }) => {
	const [isVideoOpen, setIsVideoOpen] = useState(false);

	const handlePlay = () => {
		setIsVideoOpen(true);
	};

	return (
		<>
			<div className={styles.placeholder} onClick={handlePlay}>
				<img
					src='/dist/icons/play-duotone-regular-full.svg'
					alt='play icon'
					height='60px'
				/>
			</div>
			{isVideoOpen && (
				<BaseModal
					title={item.name}
					isOpen
					onClose={() => setIsVideoOpen(false)}
					size={Size.XL}>
					<iframe
						style={{ aspectRatio: '16/9', border: 0 }}
						src={withAutoplay(item.value.playerLink)}
						width={'100%'}
						height={'auto'}
						allow={'autoplay; fullscreen'}
						allowFullScreen
					/>
				</BaseModal>
			)}
		</>
	);
};

export default EducationMaterialVideo;
